import React from "react";
import { Box, Typography, Grid2 } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { Theme } from "../Theme";
import NI from "../assets/images/NI.svg";
import AI from "../assets/images/AI.png";
import CS from "../assets/images/cyber_security.png";
import DA from "../assets/images/data_analytics.png";

export default function Services() {
  return (
    <ThemeProvider theme={Theme}>
      <Box
        sx={{
          minHeight: "100vh", // Ensure full viewport height
          background: "linear-gradient(135deg, #001d32 30%, #004080 100%)", // Gradient background
          color: "white",
          padding: "40px 20px", // Add consistent padding
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Grid2
          sx={{
            maxWidth: "900px", // Limit content width for better readability
            width: "100%",
            textAlign: "center",
            marginBottom: "40px",
          }}
        >
          <Typography variant="h1">Services We Offer</Typography>
          <Typography
            variant="body1"
            sx={{ opacity: 0.8, textAlign: "justify" }}
          >
            At Intelinext, we offer a wide range of innovative solutions
            designed to elevate your business operations, optimize workflows,
            and future-proof your technological environment. Our services span
            across various domains, ensuring that your business stays ahead in
            today’s fast-paced, digital-first world.
          </Typography>
        </Grid2>

        {/** Section: Network Infrastructure */}
        <Grid2
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // Flex layout for small screens (column) and larger screens (row)
            alignItems: "center", // Center content vertically
            justifyContent: "center", // Center content horizontally
            maxWidth: "1200px",
            width: "100%",
            backgroundColor: "#1a3953",
            borderRadius: "10px",
            padding: "20px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginBottom: "20px",
          }}
        >
          {/* Image */}
          <Grid2
            sx={{
              maxWidth: {
                xs: "100px", // Small screens
                sm: "200px", // Medium screens
                md: "300px", // Large screens
              },
              marginBottom: { md: "20px", sx: "0" }, // Margin for spacing on mobile"0px",
            }}
          >
            <img
              src={NI}
              alt="Network Infrastructure"
              style={{
                width: "100%",
                maxWidth: "300px", // Ensure the image size is manageable
              }}
            />
          </Grid2>

          {/* Text */}
          <Grid2
            sx={{
              marginLeft: { md: "20px" },
              textAlign: "center",
              maxWidth: "800px",
            }}
          >
            <Typography variant="h1">Network Infrastructure</Typography>
            <Typography variant="body0">
              <p style={{ textAlign: "justify" }}>
                Network infrastructure forms the backbone of your entire IT
                ecosystem. At Intelinext, we design, implement, and maintain
                scalable and resilient network systems that ensure seamless
                communication, efficient data flow, and optimal performance.
                Whether you’re looking to upgrade an existing network or set up
                a completely new infrastructure, our team of experts delivers
                customized solutions that align with your business goals.
              </p>

              <p style={{ textAlign: "justify" }}>
                <strong>Key Features:</strong>
              </p>
              <ul style={{ textAlign: "left" }}>
                <li>High-performance networking solutions</li>
                <li>Scalable architecture to grow with your business</li>
                <li>
                  Advanced routing and switching for enhanced connectivity
                </li>
                <li>
                  Optimized for both on-premises and cloud-based operations
                </li>
                <li>
                  Ongoing monitoring and 24/7 support for network reliability
                </li>
              </ul>

              <p style={{ textAlign: "justify" }}>
                <strong>Benefits:</strong>
              </p>
              <ul style={{ textAlign: "left" }}>
                <li>Increased productivity with seamless connectivity</li>
                <li>Reduced downtime and optimized system performance</li>
                <li>
                  Secure and reliable infrastructure for both business and
                  remote operations
                </li>
              </ul>
            </Typography>
          </Grid2>
        </Grid2>

        {/** Section: Data Analytics */}
        <Grid2
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // Flex layout for small screens (column) and larger screens (row)
            alignItems: "center", // Center content vertically
            justifyContent: "center", // Center content horizontally
            maxWidth: "1200px",
            width: "100%",
            backgroundColor: "#1a3953",
            borderRadius: "10px",
            padding: "20px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginBottom: "20px",
          }}
        >
          {/* Image */}
          <Grid2
            sx={{
              maxWidth: {
                xs: "100px", // Small screens
                sm: "200px", // Medium screens
                md: "300px", // Large screens
              },
              marginBottom: { md: "20px", sx: "0" }, // Margin for spacing on mobile"0px",
            }}
          >
            <img
              src={DA}
              alt="Data Analytics"
              style={{
                width: "100%",
                maxWidth: "300px", // Ensure the image size is manageable
              }}
            />
          </Grid2>

          {/* Text */}
          <Grid2
            sx={{
              marginLeft: { md: "20px" },
              textAlign: "center",
              maxWidth: "800px",
            }}
          >
            <Typography variant="h1">Data Analytics</Typography>
            <Typography variant="body0">
              <p style={{ textAlign: "justify" }}>
                Data is one of the most valuable assets for any business, but
                its potential is often hidden without the right tools and
                strategies. Our Data Analytics service empowers your
                organization to harness the full potential of your data. Using
                advanced techniques in predictive modeling, data mining, and
                statistical analysis, we transform raw data into actionable
                insights that help you make informed decisions, improve
                operational efficiency, and drive growth.
              </p>

              <p style={{ textAlign: "justify" }}>
                <strong>Key Features:</strong>
              </p>
              <ul style={{ textAlign: "left" }}>
                <li>Predictive analytics to forecast trends and behaviors</li>
                <li>Data visualization tools for intuitive decision-making</li>
                <li>In-depth analysis of key business metrics</li>
                <li>Integration with various data sources and systems</li>
                <li>Real-time data monitoring for faster decision-making</li>
              </ul>

              <p style={{ textAlign: "justify" }}>
                <strong>Benefits:</strong>
              </p>
              <ul style={{ textAlign: "left" }}>
                <li>Make data-driven decisions with confidence</li>
                <li>Unlock hidden business opportunities and growth areas</li>
                <li>Streamline operations and reduce inefficiencies</li>
                <li>Improve customer insights and personalized offerings</li>
              </ul>
            </Typography>
          </Grid2>
        </Grid2>

        {/** Section: Network Security */}
        <Grid2
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // Flex layout for small screens (column) and larger screens (row)
            alignItems: "center", // Center content vertically
            justifyContent: "center", // Center content horizontally
            maxWidth: "1200px",
            width: "100%",
            backgroundColor: "#1a3953",
            borderRadius: "10px",
            padding: "20px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginBottom: "20px",
          }}
        >
          {/* Image */}
          <Grid2
            sx={{
              maxWidth: {
                xs: "100px", // Small screens
                sm: "200px", // Medium screens
                md: "300px", // Large screens
              },
              marginBottom: { md: "20px", sx: "0" }, // Margin for spacing on mobile"0px",
            }}
          >
            <img
              src={CS}
              alt="Network Security"
              style={{
                width: "100%", // Responsive image width,
                maxWidth: "300px", // Ensure the image size is manageable
              }}
            />
          </Grid2>

          {/* Text */}
          <Grid2
            sx={{
              marginLeft: { md: "20px" },
              textAlign: "center",
              maxWidth: "800px",
            }}
          >
            <Typography variant="h1">Network Security</Typography>
            <Typography variant="body0">
              <p style={{ textAlign: "justify" }}>
                In today’s interconnected world, network security is crucial for
                safeguarding your business from cyber threats, data breaches,
                and potential attacks. At Intelinext, we provide comprehensive
                network security solutions designed to protect your critical
                infrastructure and sensitive data from ever-evolving threats.
                From firewalls and intrusion detection systems to encryption and
                multi-factor authentication, we employ the latest tools and
                strategies to ensure your network remains secure.
              </p>

              <p style={{ textAlign: "justify" }}>
                <strong>Key Features:</strong>
              </p>
              <ul style={{ textAlign: "left" }}>
                <li>
                  Advanced firewall and intrusion prevention systems (IPS)
                </li>
                <li>Real-time network monitoring and threat detection</li>
                <li>End-to-end encryption for sensitive data transmission</li>
                <li>Vulnerability assessments and risk analysis</li>
                <li>Multi-factor authentication for access control</li>
              </ul>

              <p style={{ textAlign: "justify" }}>
                <strong>Benefits:</strong>
              </p>
              <ul style={{ textAlign: "left" }}>
                <li>Minimized risk of data breaches and security incidents</li>
                <li>Enhanced regulatory compliance with industry standards</li>
                <li>Safeguard customer data and build trust</li>
                <li>Prevent financial losses caused by cyberattacks</li>
              </ul>
            </Typography>
          </Grid2>
        </Grid2>

        {/** Section: Artificial Intelligence (AI) */}
        <Grid2
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // Flex layout for small screens (column) and larger screens (row)
            alignItems: "center", // Center content vertically
            justifyContent: "center", // Center content horizontally
            maxWidth: "1200px",
            width: "100%",
            backgroundColor: "#1a3953",
            borderRadius: "10px",
            padding: "20px 30px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
            marginBottom: "20px",
          }}
        >
          {/* Image */}
          <Grid2
            sx={{
              maxWidth: {
                xs: "100px", // Small screens
                sm: "200px", // Medium screens
                md: "300px", // Large screens
              },
              marginBottom: { md: "20px", sx: "0" }, // Margin for spacing on mobile"0px",
            }}
          >
            <img
              src={AI}
              alt="Artificial Intelligence"
              style={{
                width: "100%",
                maxWidth: "300px", // Ensure the image size is manageable
                borderRadius: "10px",
                //boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                marginBottom: "20px", // Margin for spacing on mobile
              }}
            />
          </Grid2>

          {/* Text */}
          <Grid2
            sx={{
              marginLeft: { md: "20px" },
              textAlign: "center",
              maxWidth: "800px",
            }}
          >
            <Typography variant="h1">Artificial Intelligence (AI)</Typography>
            <Typography variant="body0">
              <p style={{ textAlign: "justify" }}>
                Artificial Intelligence is no longer a futuristic concept; it’s
                a transformative force that can enhance business processes,
                automate repetitive tasks, and provide intelligent solutions.
                Our AI services leverage the power of machine learning, natural
                language processing, and computer vision to build systems that
                learn, adapt, and make decisions based on data. Whether it’s
                chatbots for customer service or advanced AI models for
                predictive analysis, we provide tailor-made solutions that align
                with your business needs.
              </p>

              <p style={{ textAlign: "justify" }}>
                <strong>Key Features:</strong>
              </p>
              <ul style={{ textAlign: "left" }}>
                <li>Machine learning models for automation and prediction</li>
                <li>
                  Natural language processing (NLP) for customer interaction
                </li>
                <li>Computer vision for advanced image and video analysis</li>
                <li>AI-driven business process optimization</li>
                <li>Custom AI models tailored to industry-specific needs</li>
              </ul>

              <p style={{ textAlign: "justify" }}>
                <strong>Benefits:</strong>
              </p>
              <ul style={{ textAlign: "left" }}>
                <li>
                  Automate routine tasks, freeing up resources for high-impact
                  work
                </li>
                <li>
                  Improve customer experience with AI-powered tools (e.g.,
                  chatbots)
                </li>
                <li>Make more accurate business predictions and forecasts</li>
                <li>Scale business operations with AI-driven efficiency</li>
              </ul>
            </Typography>
          </Grid2>
        </Grid2>
      </Box>
    </ThemeProvider>
  );
}
